import { AlertTriangle, Inbox, CheckSquare } from 'lucide-react';

const TYPE_META = {
  task: { Icon: CheckSquare, label: 'task' },
  inbox: { Icon: Inbox, label: 'inbox' },
};

/**
 * Gentle, non-blocking hint listing pending items (tasks and/or inbox
 * entries) with near-identical titles.
 *
 * Set `compact` for dense surfaces like the CommandBar / QuickCapture
 * — same content, tighter padding and smaller type.
 */
export function SimilarTaskHint({ matches, compact = false }) {
  if (!matches?.length) return null;
  const px = compact ? 'px-2.5 py-1.5' : 'px-3 py-2';
  const titleSize = compact ? 'text-[10px]' : 'text-[11px]';
  return (
    <div
      data-testid="similar-task-hint"
      className={`rounded-xl ${px} ${compact ? '' : '-mt-1'}`}
      style={{ background: 'rgba(180, 130, 9, 0.08)', border: '1px solid rgba(180, 130, 9, 0.25)' }}
    >
      <div className="flex items-center gap-1.5 mb-1">
        <AlertTriangle className="w-3 h-3" style={{ color: 'var(--pd-warning)' }} />
        <span className="text-[10px] font-semibold" style={{ color: 'var(--pd-warning)' }}>
          Similar item{matches.length > 1 ? 's' : ''} already in your list
        </span>
      </div>
      <ul className="space-y-0.5">
        {matches.map((m) => {
          const meta = TYPE_META[m.type] || TYPE_META.task;
          const TypeIcon = meta.Icon;
          return (
            <li
              key={m.id}
              className={`flex items-center gap-2 ${titleSize}`}
              style={{ color: 'var(--pd-muted)' }}
            >
              <TypeIcon className="w-2.5 h-2.5 flex-shrink-0" style={{ color: 'var(--pd-subtle)' }} />
              <span className="truncate font-medium" style={{ color: 'var(--pd-text)' }}>{m.title}</span>
              <span className="text-[9px] uppercase flex-shrink-0" style={{ color: 'var(--pd-subtle)' }}>
                {meta.label}{m.status ? ` · ${m.status}` : ''}{m.dueDate ? ` · due ${m.dueDate}` : ''}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
